module.exports = __webpack_public_path__ + "img/Classifier2.756df0b1.png";